module.exports = __webpack_public_path__ + "img/Q-pay.97aef257.png";